// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"FormGroup_formGroup__1gK-n","vertical":"FormGroup_vertical__2xD75","label":"FormGroup_label__2jo94"};